/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface FlightSelectedBag
 */
export interface FlightSelectedBag {
  /**
   * Exact numbered bag piece. Requires quantity one and a known included_pieces count; omitted for fungible quantity services.
   * @type {number}
   * @memberof FlightSelectedBag
   */
  pieceOrdinal?: number;
  /**
   * Authoritative included piece count for every passenger and segment in this service scope. Unknown counts must be omitted, never inferred as zero.
   * @type {number}
   * @memberof FlightSelectedBag
   */
  includedPieces?: number;
  /**
   * Opaque provider-bound bag service reference for exact authentication. Not purchase authorization; clients must not reconstruct supplier identities from it.
   * @type {string}
   * @memberof FlightSelectedBag
   */
  serviceReference?: string;
  /**
   *
   * @type {Array<number>}
   * @memberof FlightSelectedBag
   */
  passengerIndices: Array<number>;
  /**
   *
   * @type {Array<number>}
   * @memberof FlightSelectedBag
   */
  segmentIndices: Array<number>;
  /**
   *
   * @type {string}
   * @memberof FlightSelectedBag
   */
  baggageType: FlightSelectedBagBaggageTypeEnum;
  /**
   *
   * @type {string}
   * @memberof FlightSelectedBag
   */
  unitAmount: string;
  /**
   *
   * @type {string}
   * @memberof FlightSelectedBag
   */
  currency: string;
  /**
   *
   * @type {number}
   * @memberof FlightSelectedBag
   */
  quantity: number;
}

/**
 * @export
 */
export const FlightSelectedBagBaggageTypeEnum = {
  Checked: "checked",
  CarryOn: "carry_on",
} as const;
export type FlightSelectedBagBaggageTypeEnum =
  (typeof FlightSelectedBagBaggageTypeEnum)[keyof typeof FlightSelectedBagBaggageTypeEnum];

/**
 * Check if a given object implements the FlightSelectedBag interface.
 */
export function instanceOfFlightSelectedBag(
  value: object
): value is FlightSelectedBag {
  if (!("passengerIndices" in value) || value["passengerIndices"] === undefined)
    return false;
  if (!("segmentIndices" in value) || value["segmentIndices"] === undefined)
    return false;
  if (!("baggageType" in value) || value["baggageType"] === undefined)
    return false;
  if (!("unitAmount" in value) || value["unitAmount"] === undefined)
    return false;
  if (!("currency" in value) || value["currency"] === undefined) return false;
  if (!("quantity" in value) || value["quantity"] === undefined) return false;
  return true;
}

export function FlightSelectedBagFromJSON(json: any): FlightSelectedBag {
  return FlightSelectedBagFromJSONTyped(json, false);
}

export function FlightSelectedBagFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FlightSelectedBag {
  if (json == null) {
    return json;
  }
  return {
    pieceOrdinal:
      json["piece_ordinal"] == null ? undefined : json["piece_ordinal"],
    includedPieces:
      json["included_pieces"] == null ? undefined : json["included_pieces"],
    serviceReference:
      json["service_reference"] == null ? undefined : json["service_reference"],
    passengerIndices: json["passenger_indices"],
    segmentIndices: json["segment_indices"],
    baggageType: json["baggage_type"],
    unitAmount: json["unit_amount"],
    currency: json["currency"],
    quantity: json["quantity"],
  };
}

export function FlightSelectedBagToJSON(json: any): FlightSelectedBag {
  return FlightSelectedBagToJSONTyped(json, false);
}

export function FlightSelectedBagToJSONTyped(
  value?: FlightSelectedBag | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    piece_ordinal: value["pieceOrdinal"],
    included_pieces: value["includedPieces"],
    service_reference: value["serviceReference"],
    passenger_indices: value["passengerIndices"],
    segment_indices: value["segmentIndices"],
    baggage_type: value["baggageType"],
    unit_amount: value["unitAmount"],
    currency: value["currency"],
    quantity: value["quantity"],
  };
}
